import React from "react";
import {Redirect, Route} from "react-router-dom";
import get from "lodash/get";
import AnalyticsValue from "shared/AnalyticsNew/AnalyticsValue/AnalyticsValue";
import {productSpec} from "shared/AnalyticsNew/constants/productSpecification";
import withAuth from "shared/Auth/withAuth/withAuth";
import {isFeatureEnabled} from "shared/Utils/FeatureUtils";

const Inbox = React.lazy(() =>
    import(
        /* webpackChunkName: "inbox" */ "./modules/Inbox/components/InboxRoutes/InboxRoutes"
    ),
);
const Blog = React.lazy(() =>
    import(
        /* webpackChunkName: "blog" */ "./modules/Blog/Blog"
    ),
);
const Profile = React.lazy(() =>
    import(
        // eslint-disable-next-line comma-dangle
        /* webpackChunkName: "profile" */ "./modules/Profile/components/ProfileRoutes/ProfileRoutes"
    ),
);
const Settings = React.lazy(() =>
    import(
        // eslint-disable-next-line comma-dangle
        /* webpackChunkName: "settings" */ "./modules/Settings/components/SettingsRoutes/SettingsRoutes"
    ),
);
const Questions = React.lazy(() =>
    import(
        // eslint-disable-next-line comma-dangle
        /* webpackChunkName: "questions" */ "./modules/Questions/components/Questions/Questions"
    ),
);
const TimeSheet = React.lazy(() =>
    import(
        /* webpackChunkName: "time-sheet" */ "./modules/TimeSpent/components/TimeSheet"
    ),
);

export const ProtectedRoutesComponent = withAuth((parentProps) => {
    const isMentor = get(parentProps, "me.anyUser.accountRole") === "mentor";
    const authState = get(parentProps, "authState", {});
    const university = get(parentProps, "university", {});
    if (!parentProps.authState.me) {
        return <Redirect to="/auth/login" />;
    }
    return (
        <React.Fragment>
            <AnalyticsValue
                name={
                    productSpec.ambassadorDashboard.properties.UNIVERSITY_SLUG
                }
                value={
                    get(parentProps, "me.mentor.university.slug") ||
                    get(parentProps, "me.staff.university.slug")
                }
            />
            <AnalyticsValue
                name="accountRole"
                value={get(parentProps, "me.anyUser.accountRole")}
            />
            <AnalyticsValue
                name={productSpec.ambassadorDashboard.properties.PRODUCT}
                value={productSpec.ambassadorDashboard.NAME}
            />

            <Route path="/inbox" render={(props) => <Inbox {...props} />} />
            {isFeatureEnabled("userGeneratedContent", university) && (
                <Route
                    path="/blog"
                    render={(props) => (
                        <Blog university={university} authState={authState} {...props} />
                    )}
                />
            )}
           {isMentor ? (
                <Route
                    path="/time-sheet"
                    render={(props) => (
                        <TimeSheet university={university} {...props} />
                    )}
                />
            ) : null}
            {isMentor && isFeatureEnabled("buddiesSavedAnswer", university) ? (
                <Route
                    path="/saved-answers"
                    render={(props) => <Questions {...props} />}
                />
            ) : null}
            <Route
                path="/profile"
                render={(props) => (
                    <Profile university={university} {...props} />
                )}
            />
            <Route
                path="/settings"
                render={(props) => <Settings {...props} />}
            />
            <Route
                path="/buddies"
                render={(props) => <Blog university={university} {...props} />}
            />
        </React.Fragment>
    );
});

export default ProtectedRoutesComponent;
